import React from 'react';
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { redo as _redo, undo as _undo } from '@atlaskit/editor-prosemirror/history';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { attachInputMeta } from './pm-plugins/attach-input-meta';
import { keymapPlugin } from './pm-plugins/keymaps';
import { createPlugin } from './pm-plugins/main';
// eslint-disable-next-line @atlassian/tangerine/import/entry-points
// Ignored via go/ees005
// eslint-disable-next-line import/no-named-as-default
import ToolbarUndoRedo from './ui/ToolbarUndoRedo';
export var undoRedoPlugin = function undoRedoPlugin(_ref) {
  var api = _ref.api;
  var editorViewRef = {
    current: null
  };
  var primaryToolbarComponent = function primaryToolbarComponent(_ref2) {
    var editorView = _ref2.editorView,
      disabled = _ref2.disabled,
      isToolbarReducedSpacing = _ref2.isToolbarReducedSpacing;
    return /*#__PURE__*/React.createElement(ToolbarUndoRedo, {
      isReducedSpacing: isToolbarReducedSpacing,
      disabled: disabled,
      editorView: editorView,
      api: api
    });
  };
  if (editorExperiment('platform_editor_controls', 'control', {
    exposure: true
  })) {
    var _api$primaryToolbar;
    api === null || api === void 0 || (_api$primaryToolbar = api.primaryToolbar) === null || _api$primaryToolbar === void 0 || _api$primaryToolbar.actions.registerComponent({
      name: 'undoRedoPlugin',
      component: primaryToolbarComponent
    });
  }
  return {
    name: 'undoRedoPlugin',
    actions: {
      undo: function undo(inputSource) {
        if (!editorViewRef.current) {
          return false;
        }
        var _editorViewRef$curren = editorViewRef.current,
          state = _editorViewRef$curren.state,
          dispatch = _editorViewRef$curren.dispatch;
        if (!inputSource) {
          return _undo(state, dispatch);
        }
        return attachInputMeta(inputSource)(_undo)(state, dispatch);
      },
      redo: function redo(inputSource) {
        if (!editorViewRef.current) {
          return false;
        }
        var _editorViewRef$curren2 = editorViewRef.current,
          state = _editorViewRef$curren2.state,
          dispatch = _editorViewRef$curren2.dispatch;
        if (!inputSource) {
          return _redo(state, dispatch);
        }
        return attachInputMeta(inputSource)(_redo)(state, dispatch);
      }
    },
    pmPlugins: function pmPlugins() {
      var plugins = [{
        name: 'undoRedoKeyMap',
        plugin: function plugin() {
          return keymapPlugin();
        }
      }, {
        name: 'undoRedoPlugin',
        plugin: function plugin(options) {
          return createPlugin(options);
        }
      }];
      if (editorExperiment('platform_editor_controls', 'variant1', {
        exposure: false
      })) {
        plugins.push({
          name: 'undoRedoGetEditorViewReferencePlugin',
          plugin: function plugin() {
            return new SafePlugin({
              view: function view(editorView) {
                editorViewRef.current = editorView;
                return {
                  destroy: function destroy() {
                    editorViewRef.current = null;
                  }
                };
              }
            });
          }
        });
      }
      return plugins;
    },
    primaryToolbarComponent: !(api !== null && api !== void 0 && api.primaryToolbar) && editorExperiment('platform_editor_controls', 'control', {
      exposure: true
    }) ? primaryToolbarComponent : undefined
  };
};